import i18n from 'i18next';
import cnTrans from './zh-CN.json';
import enTrans from './en-US.json';

i18n.on('initialized', () => {
  i18n.addResourceBundle('zh-CN', 'translation', { score: cnTrans }, true);
  i18n.addResourceBundle('en-US', 'translation', { score: enTrans }, true);
  console.log('[I18n Init] Writing Score');
});
